/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, Input, OnChanges, OnDestroy} from '@angular/core';
import template from './role-analysis-page.component.html';

import {loadRoleAnalysisUsers} from './role-commons';
import {TeamResource} from '../../../components/api/resources/resource/team.resource';
import {UserResource} from '../../../components/api/resources/resource/user.resource';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {createBufferedFlag, readBufferedFlag} from '../../common/util/template-state';

@Component({
  standalone: false,
  selector: 'adn-role-analysis-page',
  template
})
export class RoleAnalysisPageComponent implements OnChanges, OnDestroy {
  @Input() model: any;
  @Input() modelComms: any;
  @Input() isNew: boolean;

  users: any[] = [];
  loading = false;
  loaded = false;
  private readonly loadedFlag = createBufferedFlag();
  private destroyed = false;

  constructor(
    @Inject(TeamResource) private Team: any,
    @Inject(UserResource) private User: any,
    @Inject(LocalNetworkProfile) private LocalNetworkProfile: any,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  get displayLoaded(): boolean {
    return readBufferedFlag(this.loadedFlag, this.loaded, this.cdr, () => !this.destroyed);
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }

  ngOnChanges(): void {
    this.refreshUsers();
  }

  trackByUserId(_index: number, user: any): string {
    return user.id;
  }

  trackByTeamId(_index: number, team: any): string {
    return team.id || team.name;
  }

  private refreshUsers(): void {
    if (this.isNew || !this.model?.id) {
      this.users = [];
      this.loading = false;
      this.loaded = true;
      return;
    }

    this.loading = true;
    this.loaded = false;
    loadRoleAnalysisUsers(this.model, this.Team, this.User, this.LocalNetworkProfile).then((users) => {
      this.users = users;
      this.loading = false;
      this.loaded = true;
    }).catch(() => {
      this.users = [];
      this.loading = false;
      this.loaded = true;
    });
  }
}
